import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CbmService {
  private readonly baseURL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // ─── Cash Book ───────────────────────────────────────────────
  getAllCashBooks(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/cash-book/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCashBookById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash-book/get-by-id?id=${id}`);
  }

  createCashBook(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/cash-book/create`, entity);
  }

  updateCashBook(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/cash-book/update`, entity);
  }

  // ─── Cash Book Tag ────────────────────────────────────────────
  getAllCashBookTags(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/cash-book-tag/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCashBookTagsByCashBookId(cashBookId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash-book-tag/get-by-cash-book-id?cashBookId=${cashBookId}`);
  }

  createCashBookTag(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/cash-book-tag/create`, entity);
  }

  updateCashBookTag(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/cash-book-tag/update`, entity);
  }

  // ─── Cash Book Linked Table ───────────────────────────────────
  getAllCashBookLinkedTables(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/cash-book-linked-table/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCashBookLinkedTablesByCashBookId(cashBookId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash-book-linked-table/get-by-cash-book-id?cashBookId=${cashBookId}`);
  }

  createCashBookLinkedTable(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/cash-book-linked-table/create`, entity);
  }

  updateCashBookLinkedTable(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/cash-book-linked-table/update`, entity);
  }

  // ─── Transaction Type ─────────────────────────────────────────
  getAllTransactionTypes(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/transaction-type/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getTransactionTypeById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction-type/get-by-id?id=${id}`);
  }

  createTransactionType(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-type/create`, entity);
  }

  updateTransactionType(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/transaction-type/update`, entity);
  }

  // ─── Payment Method ───────────────────────────────────────────
  getAllPaymentMethods(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/payment-method/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getPaymentMethodById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/payment-method/get-by-id?id=${id}`);
  }

  createPaymentMethod(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/payment-method/create`, entity);
  }

  updatePaymentMethod(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/payment-method/update`, entity);
  }

  // ─── Party Type ───────────────────────────────────────────────
  getAllPartyTypes(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/party-type/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getPartyTypeById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/party-type/get-by-id?id=${id}`);
  }

  createPartyType(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/party-type/create`, entity);
  }

  updatePartyType(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/party-type/update`, entity);
  }

  // ─── Party Type Linked Table ──────────────────────────────────
  getPartyTypeLinkedTablesByPartyTypeId(partyTypeId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/party-type-linked-table/get-by-party-type-id?partyTypeId=${partyTypeId}`);
  }

  createPartyTypeLinkedTable(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/party-type-linked-table/create`, entity);
  }

  updatePartyTypeLinkedTable(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/party-type-linked-table/update`, entity);
  }

  // ─── Transaction ──────────────────────────────────────────────
  getAllTransactions(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/transaction/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getTransactionById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction/get-by-id?id=${id}`);
  }

  createTransaction(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction/create`, entity);
  }

  saveCbmTransaction(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction/save`, entity);
  }

  saveCbmTransactionPosted(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction/posted/save`, entity);
  }

  getNextDocumentNo(transactionTypeId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction/get-next-document-no?transactionTypeId=${transactionTypeId}`);
  }

  updateTransaction(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/transaction/update`, entity);
  }

  getTransactionDetails(searchCriteria: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction/details`, searchCriteria);
  }
  // ─── Transaction File ─────────────────────────────────────────
  createTransactionFiles(dto: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-file/create-files`, dto);
  }

  getTransactionFilesByTransactionId(transactionId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction-file/get-by-transaction-id?transactionId=${transactionId}`);
  }

  // ─── Transaction Tag ──────────────────────────────────────────
  createTransactionTag(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-tag/create`, entity);
  }

  getTransactionTagsByTransactionId(transactionId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction-tag/get-by-transaction-id?transactionId=${transactionId}`);
  }

  // ─── Transaction Linked Object ────────────────────────────────
  createTransactionLinkedObject(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-linked-object/create`, entity);
  }

  getTransactionLinkedObjectsByTransactionId(transactionId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction-linked-object/get-by-transaction-id?transactionId=${transactionId}`);
  }

  // ─── Transaction Detail ───────────────────────────────────────
  createTransactionDetail(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-detail/create`, entity);
  }

  updateTransactionDetail(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/transaction-detail/update`, entity);
  }

  getTransactionDetailsByTransactionId(transactionId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/transaction-detail/get-by-transaction-id?transactionId=${transactionId}`);
  }

  saveTransactionDetail(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-detail/save`, data);
  }

  // ─── Transaction Detail File ──────────────────────────────────
  createTransactionDetailFiles(dto: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction-detail-file/create-files`, dto);
  }

  // ─── Push To Odoo ──────────────────────────────────
  pushToOdoo(transactionId: number): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/transaction/push-to-odoo/${transactionId}`, {});
  }

  // ─── Cash Book Linked Object ───────────────────────────────────
  getAllCashBookLinkedObject(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/cash/book/linked/object/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCashBookLinkedObjectByCashBookId(cashBookId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash/book/linked/object/get-by-cash-book-id?cashBookId=${cashBookId}`);
  }

  createCashBookLinkedObject(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/cash/book/linked/object/create`, entity);
  }

  updateCashBookLinkedObject(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/cash/book/linked/object/update`, entity);
  }

  getCashBookLinkedObjectsByCashBookId(cashBookId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash/book/linked/object/get-by-cash-book-id?cashBookId=${cashBookId}`);
  }

  // ─── Party Type Linked Table ──────────────────────────────────
  getPartyTypeLinkedObjectByPartyTypeId(partyTypeId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/party/type/linked/object/get-by-party-type-id?partyTypeId=${partyTypeId}`);
  }

  createPartyTypeLinkedObject(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/party/type/linked/object/create`, entity);
  }

  updatePartyTypeLinkedObject(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/party/type/linked/object/update`, entity);
  }

  getCashBookTagsAndLinkedObjectsByCashBookId(cashBookId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/cash-book/get-tags-and-linked-objects-by-cash-book-id?cashBookId=${cashBookId}`);
  }
}
